import * as React from "react";
import {RouteComponentProps} from "react-router";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {Button} from "reactstrap";
import Modal from "reactstrap/lib/Modal";
import ModalHeader from "reactstrap/lib/ModalHeader";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalFooter from "reactstrap/lib/ModalFooter";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    productHelper,
    ProductsEnum,
    Quote,
    resourcesHelper,
    Types
} from "@falcon/services";
import {authorize} from "@athena-portal/components";
import {BackButton} from "../../../../components/navigation/BackButton";
import {Link} from "react-router-dom";
import {lazyInject} from "@athena-portal/core";

interface IGetNewQuotePageProps extends RouteComponentProps {
    location: any;
}

enum LvProducts {
    PET = "PET",
    TRAVEL = "TRAVEL"
}

enum Modals {
    ALLIANZ = "ALLIANZ",
    LV = "LV"
}

const productNameMap = {
    [ProductsEnum.WOLF_MOTOR]: "car",
    [ProductsEnum.HOME]: "home",
};

type AllProducts = ProductsEnum | LvProducts;

interface IGetNewQuotePageState {
    showModal?: Modals;
    selectedProduct?: AllProducts;
    selectedProductName: string;
    annualMotorQuotes: Quote[];
    annualHomeQuotes: Quote[];
}

@authorize
export class GetNewQuotePage extends React.Component<IGetNewQuotePageProps, IGetNewQuotePageState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();
    private readonly ANNUAL_MOTOR_ENABLED = process.env.REACT_APP_ANNUAL_MOTOR_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_MOTOR_ENABLED) : true;
    private readonly ANNUAL_HOME_ENABLED = process.env.REACT_APP_ANNUAL_HOME_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_HOME_ENABLED) : true;
    private readonly MOTOR_QUOTES_PAGE: string = "/dashboard/annualQuotes";
    private readonly HOME_QUOTES_PAGE: string = "/dashboard/HomeInsuranceQuotes";

    constructor(props: Readonly<IGetNewQuotePageProps>) {
        super(props);
        this.state = {
            showModal: undefined,
            selectedProduct: undefined,
            selectedProductName: "",
            annualMotorQuotes: [],
            annualHomeQuotes: [],
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Get a new quote");
        this.fetchQuotes();
    }

    private fetchQuotes = () => {
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => {
            this.setState({
                annualMotorQuotes: this.getQuotesByProduct(quotes, ProductsEnum.WOLF_MOTOR),
                annualHomeQuotes: this.getQuotesByProduct(quotes, ProductsEnum.HOME)
            });
        });
    }

    public render = () => {
        return (
            <>
                <FalconHeader/>
                <div id="noPaddingBottomPlugin" className="plugin">
                    <FalconNavigatorHeader back="/dashboard" title="Get a new quote"/>

                    {this.renderQuoteChoice()}
                    {this.renderRenewalDateCapturePanel()}
                </div>
                {this.renderLVQuotes()}
                <FalconFooter/>
                <GetNewQuoteModal
                    isOpen={this.state.showModal === Modals.ALLIANZ}
                    closeModal={this.closeModal}
                    navigateToPage={this.navigateToPage}
                    selectedProduct={this.state.selectedProduct}
                    selectedProductName={this.state.selectedProductName}
                />
                <GetLvQuoteModal
                    isOpen={this.state.showModal === Modals.LV}
                    closeModal={this.closeModal}
                    navigateToPage={this.navigateToPage}
                    selectedProduct={this.state.selectedProduct}
                />
            </>
        );
    }

    private renderLVQuotes = () => {
        // @ts-ignore
        const QuoteButton = ({ onClick, text }) => (
            <div className="get-quote-button">
                <Button onClick={onClick} className="btn btn-primary btn-next-no-arrow m-0-desktop">
                    {text}
                </Button>
            </div>
        );

        // @ts-ignore
        const QuoteHeader = ({ productType }) => (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="product-title">LV= {productType} insurance</div>
                <div style={{ textAlign: 'right' }}>
                    <b>10%</b><br />
                    discount
                </div>
            </div>
        );

        const discountMobileDiv = <div className="discount-mobile">
            <p><b>10%</b> <span className="small">online discount</span></p>
        </div>;
        const discountDesktopDiv = <div className="quote-right-column">
            <b>10%</b>
            <p className="small">online discount</p>
        </div>;

        return (
            <>
                <div className="travel-pet-get-quote">
                    <div className="product-context-wide">
                        <div className="horizontal-positioner">
                            <div className="horizontal-panel-get-quote">
                                <div>
                                    <img className="quote-flourish" src="/Allianz/img/travel-defaqto-flourish.svg"
                                         alt="Defaqto 5 star rated Premier policy"/>
                                </div>
                                {discountMobileDiv}
                                <div className="quote-mid-column">
                                    <div className="product-title">LV= travel insurance</div>

                                    <p className="product-description">
                                        Thinking of booking a holiday?<br/>
                                        Pick between single trip cover or an annual multi-trip policy!<br/>
                                        A <b>10% discount</b> when you buy online.<br/>
                                    </p>
                                    <QuoteButton onClick={() => this.openModal(LvProducts.TRAVEL)}
                                                 text="Get a travel quote"/>
                                </div>
                                {discountDesktopDiv}
                            </div>

                            <div className="horizontal-panel-get-quote">
                                <div>
                                    <img className="quote-flourish" src="/Allianz/img/pet-defaqto-flourish.svg"
                                         alt="Defaqto 5 star rated Pet policy"/>
                                </div>
                                {discountMobileDiv}
                                <div className="quote-mid-column">
                                    <div className="product-title">LV= pet insurance</div>

                                    <p className="product-description">
                                        We're here when your cats and dogs need more than a little TLC.<br/>
                                        Get a <b>10% discount</b> for your first year of cover when you buy online.<br/>
                                    </p>
                                    <QuoteButton onClick={() => this.openModal(LvProducts.PET)} text="Get a pet quote"/>
                                </div>
                                {discountDesktopDiv}
                            </div>

                            <div className="lv-company-allianz">
                                <img className="lv-company-allianz" src="/Allianz/img/LV-Allianz.png"/>
                            </div>
                        </div>
                    </div>

                    <div className="before-footer">
                        <div className="horizontal-positioner" id="horizontal-positioner-back-button">
                            <BackButton isTop={false} link={"/dashboard"}/>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    private renderQuoteChoice = () => {
        return (
                <div className="get-quote-allianz mx-3">
                    {this.ANNUAL_MOTOR_ENABLED && this.renderAnnualMotorTile()}
                    {this.ANNUAL_HOME_ENABLED && this.renderAnnualHomeTile()}
                </div>
        )
    }

    private renderAnnualMotorTile = () => {
        const annualMotorQuoteCount: number = this.state.annualMotorQuotes.length;
        const hasAnnualMotorQuotes: boolean = annualMotorQuoteCount > 0;
        return (
            <div className="section-panel-get-quote">
                {this.renderQuoteCountWording(annualMotorQuoteCount)}
                <div className="content-above-button">
                    <div className="logo-grid">
                        <div/>
                        <img className="car-logo" src={`/${resourcesHelper.THEME}/img/wolf-car-icon.png`}
                             alt="car icon"/>
                        <img className="defaqto-logo" src="/img/DefaqtoLogo.svg" alt="Defaqto logo"
                             aria-label="Defaqto logo"/>
                    </div>
                    <div className="section overflow-hidden text-center">
                        <div className="product-title">Comprehensive car insurance</div>
                        {PluginTemplates.getNewQuoteWording[ProductsEnum.WOLF_MOTOR]}
                    </div>
                </div>
                <div className="get-quote-button">
                    {hasAnnualMotorQuotes ? <Link to={this.MOTOR_QUOTES_PAGE} className="buttonLink w-100">
                            <button type="button"
                                    id={"test"}
                                    className="btn btn-primary m-0-desktop">
                                View your car quote
                            </button>
                        </Link>
                        : <Button onClick={() => this.openModal(ProductsEnum.WOLF_MOTOR)}
                                  className="btn btn-primary btn-next-no-arrow m-0-desktop">Car quote</Button>}
                </div>
                <div className="quote-panel-view-quotes mt-4">
                    {hasAnnualMotorQuotes ? <Link className="text-decoration-underline muli-bold-16" to={'#'} onClick={() => this.openModal(ProductsEnum.WOLF_MOTOR)}>
                            Get a new car quote
                        </Link>
                        : <p className="mb-0">You don’t have any car quotes</p>
                    }
                </div>
            </div>
        );
    }

    private renderQuoteCountWording = (quoteCount: number) => {
        const quoteText: string = quoteCount === 1 ? " quote" : " quotes";
        return (
            <div className="valid-quote-counter">
                <p>You have <span className="muli-bold-16">{quoteCount}</span> {quoteText}</p>
            </div>
        );
    }

    private renderAnnualHomeTile = () => {
        const annualHomeQuoteCount: number = this.state.annualHomeQuotes.length;
        const hasHomeQuotes: boolean = annualHomeQuoteCount > 0;
        return (
            <div className="section-panel-get-quote">
                {this.renderQuoteCountWording(annualHomeQuoteCount)}
                <div className="content-above-button">
                    <div className="logo-grid">
                        <div/>
                        <img className="home-logo" src={`/${resourcesHelper.THEME}/img/home-icon.png`}
                             alt="home icon"/>
                        <img className="defaqto-logo" src="/img/DefaqtoLogoHome.svg" alt="Defaqto logo"
                             aria-label="Defaqto logo"/>
                    </div>
                    <div className="section overflow-hidden text-center">
                        <div className="product-title">Buildings and contents home insurance</div>
                        {PluginTemplates.getNewQuoteWording[ProductsEnum.HOME]}
                    </div>
                </div>
                <div className="get-quote-button">
                    {hasHomeQuotes ? <Link to={this.HOME_QUOTES_PAGE} className="buttonLink w-100">
                            <button type="button"
                                    id={"test"}
                                    className="btn btn-primary m-0-desktop">
                                View your home quote
                            </button>
                        </Link>
                        : <Button onClick={() => this.openModal(ProductsEnum.HOME)}
                                  className="btn btn-primary btn-next-no-arrow m-0-desktop">Home quote</Button>}
                </div>
                <div className="quote-panel-view-quotes mt-4">
                    {hasHomeQuotes ? <Link className="text-decoration-underline muli-bold-16" to={'#'} onClick={() => this.openModal(ProductsEnum.HOME)}>
                                Get a new home quote
                            </Link>
                            : <p className="mb-0">You don’t have any home quotes</p>
                    }
                </div>

            </div>
        )
    }

    private renderRenewalDateCapturePanel = () => {
        return (
            <div className="banner banner-content">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <span className="font-weight-bold">Not the right time for a quote?</span>
                    <p className="mt-3">If you have a policy with another insurer, just let us know when it's due for
                        renewal.</p>
                    <p className="mt-3">We'll get in touch before your renewal date so you can get a quote from us and
                        compare it with
                        your current provider.{' '}
                        <a href={"https://cloud.comms.allianz.co.uk/RenewalDateCapture"} id="renewal-date-capture-link">Let
                            us know</a>
                    </p>
                </div>
            </div>
        )
    }

    private isAllianz(productType: AllProducts): boolean {
        return (Object.values(ProductsEnum) as AllProducts[]).includes(productType);
    }

    private openModal = (productType: AllProducts) => {
        const showModal = this.isAllianz(productType) ? Modals.ALLIANZ : Modals.LV;

        this.setState({
            showModal,
            selectedProduct: productType,
            selectedProductName: productNameMap[productType] || "defaultName",
        })
    }

    private closeModal = () => {
        this.setState({showModal: undefined, selectedProduct: undefined})
    }

    private navigateToPage = () => {
        const homeQuickQuoteEnabled: boolean = process.env.REACT_APP_HOME_QUICK_QUOTE_ENABLED ? JSON.parse(process.env.REACT_APP_HOME_QUICK_QUOTE_ENABLED) : false;
        const product = this.state.selectedProduct;
        const entryPage: string = product === ProductsEnum.HOME && homeQuickQuoteEnabled ? "quickQuotePresetPage" : "dashboardEntryPage";

        if (product) {
            if (product === LvProducts.PET) {
                window.open("https://securepet.lv.co.uk/your-pet?partner=lv&sourcecode=LVNW&utm_source=allianz&utm_medium=referral&utm_campaign=pet-cross-sell&utm_content=get-a-quote",
                    '_blank')
            } else if (product === LvProducts.TRAVEL) {
                window.open("https://lv-travel.co.uk/travel/travel.trav?brand=LV&annual=n&partner=direct&sourcecode=IELO&reqaction=QUOTE&utm_source=allianz&utm_medium=referral&utm_campaign=travel-cross-sell&utm_content=get-a-quote",
                    '_blank')
            } else {
                this.props.history.push(`${productHelper.getNewBusinessUrl(product)}/${entryPage}`);
            }
        }
    }

    private getQuotesByProduct(quotes: Quote[], product: string): Quote[] {
        return quotes?.filter((quote) => quote?.product === product);
    }
}

interface IGetNewQuoteModalProps {
    isOpen: boolean;
    closeModal: () => void;
    navigateToPage: (event: any) => void;
    selectedProduct?: AllProducts;
    selectedProductName: string;
}

interface IGetLvQuoteModalProps {
    isOpen: boolean;
    closeModal: () => void;
    navigateToPage: (event: any) => void;
    selectedProduct: AllProducts | undefined;
}

const GetNewQuoteModal: React.FC<IGetNewQuoteModalProps> = ({isOpen, closeModal, navigateToPage, selectedProduct, selectedProductName}) => (
    <Modal className="custom-info-modal" isOpen={isOpen} toggle={closeModal} id="getNewQuoteModal">
        <ModalHeader toggle={closeModal}>
            <div className="d-flex">
                <img src="/img/Flow-info-selected.svg" alt="Info icon"/>
                <span
                    className="ml-3 text-blue-2 fs-20 font-weight-medium">Before getting a quote for a new {selectedProductName} policy...</span>
            </div>
        </ModalHeader>
        <ModalBody className="pt-0">
            {getModalBody(selectedProduct)}
        </ModalBody>
        <ModalFooter className="my-2 w-100">
            <button type="button" className="btn btn-primary btn-next-no-arrow w-100" onClick={navigateToPage}
                    id="accept-btn">Ok, I understand
            </button>
        </ModalFooter>
    </Modal>
);

function getModalBody(selectedProduct?: AllProducts) {
    if (selectedProduct === ProductsEnum.WOLF_MOTOR) {
        return (<>
            <p className="font-weight-semi-bold">Your existing account details will be used to create a new policy
                for your vehicle.<br/>The new policy will have:</p>
            <p className="font-weight-extra-light">● The same email address as the existing policy</p>
            <p className="font-weight-extra-light">● The same policyholder as the existing policy</p>
            <p className="font-weight-extra-light">● The same address as the existing policy</p>
            <p className="font-weight-extra-light">You'll use your existing account to access and manage this new
                policy. If any information is incorrect
                or needs updating, please update your existing policy before continuing</p>
            <p className="font-weight-extra-light">Alternatively, to set up a policy with a different policyholder,
                please <a href={"https://www.allianz.co.uk/insurance/car-insurance.html"}>start a new quote</a></p>
        </>);
    } else {
        return (<>
            <p className="font-weight-semi-bold">To get new policies in the existing account please check the
                following:</p>
            <p className="font-weight-extra-light">● The new policy use the same email address as the existing
                policy;</p>
            <p className="font-weight-extra-light">● The policyholder must have the same name and date of birth as on
                the existing policy;</p>
            <p className="font-weight-extra-light">● The policyholder must live at the same address as on the existing
                policy.</p>
        </>);
    }
}

const GetLvQuoteModal: React.FC<IGetLvQuoteModalProps> = ({isOpen, closeModal, navigateToPage, selectedProduct}) => {
    const productName = (selectedProduct === LvProducts.PET) ? "pet" : "travel";
    return (
        <Modal className="custom-info-modal travel-pet-get-quote" isOpen={isOpen} toggle={closeModal} id="getLvQuoteModal">
            <ModalHeader toggle={closeModal}>
                <div className="d-flex">
                    <img src="/img/Flow-info-selected.svg" alt="Info icon"/>
                    <span
                        className="ml-3 text-blue-2 fs-20 font-weight-medium">Buying an LV= policy</span>
                </div>
            </ModalHeader>
            <ModalBody className="pt-0">
                <p className="font-weight-extra-light">Just so you know, if you buy
                    LV= {productName} insurance, it won’t appear in
                    your Allianz account. It’s a separate policy and LV= will send you everything you need.</p>
            </ModalBody>
            <ModalFooter className="my-2 w-100">
                <button type="button" className="btn no-margin-top btn-back btn-next-no-arrow w-100"
                        onClick={closeModal}
                        id="accept-btn">Cancel
                </button>
                <button type="button" className="btn no-margin-top btn-primary btn-next-no-arrow w-100"
                        onClick={navigateToPage}
                        id="accept-btn">Get a {productName} quote
                </button>
            </ModalFooter>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/quotesPage/GetNewQuotePage.tsx